// src/loaders/stlLoader.js
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js'
import {
  createMesh,
  centerAndOrientGeometry,
  mergeAndNormalizeGeometry,
  setupColorAttribute,
  setupWeightAttribute,
} from './loaderUtils'

/**
 * Load STL model from a path or Blob URL
 * @param {string} pathOrBlobUrl - File path or Blob URL
 * @returns {Promise<THREE.Mesh>}
 */
export function loadSTL(pathOrBlobUrl) {
  return new Promise((resolve, reject) => {
    const loader = new STLLoader()
    loader.load(
      pathOrBlobUrl,
      (geometry) => {
        // Center and orient geometry
        centerAndOrientGeometry(geometry)

        // Merge vertices and compute normals
        // **CRITICAL**: mergeVertices() returns a new indexed geometry object
        // We must capture the return value to ensure proper indexing across all loaders
        geometry = mergeAndNormalizeGeometry(geometry, 1e-4, 'STL')

        // Setup color attribute with face color expansion (STL files may have per-face colors)
        setupColorAttribute(geometry, { expandFaceColors: true })

        // Setup weight attribute
        setupWeightAttribute(geometry)

        // Create mesh with standard material
        const mesh = createMesh(geometry, 'STLMesh')
        resolve(mesh)
      },
      undefined,
      reject
    )
  })
}
